import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseInvalidDateAndFormat, getFormattedTimeWithTimeZone } from 'common/utilities/dayJsUtils';
import { withRouter } from 'react-router-dom';
import { AnchorWithLink } from 'atoms/Anchor';
import { UserOrderContext } from 'context/context';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { getFacilities } from 'common/utilities/amenities';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getValueOrDefaultObject,
  isEmptyEvery,
  setSearchStoreByAtrribute,
  setStoreOutOfService,
  getAndCheckIfOneTrue,
  currentTimeOfStore,
  removeColonFromTime,
} from 'common/utilities/utils';
import { getMiles } from './SearchStoreCard';
import { getList } from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { setOrderLaterAnalyticsData } from '../SearchStoreUtilities/SearchStoreUtils';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import { DATE_FORMATS, WEEKDAYNAME, EVERYDAY } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { FavoriteUnfillImage, FavoriteFillImage, GreenTickImage } = IMAGE_PATH;

const { BROWSE_MENU, PICK_UP, TAKE_AWAY, STORE_STATUS_CLOSED_CAPS, STORE_STATUS_CLOSED, INDIA } =
  SEARCH_STORE_CONSTANTS;

const getOrderItemsName = store => {
  return store === PICK_UP ? TAKE_AWAY : store;
};
export const getTodayStartTime = (storeStatus, format) => {
  if (storeStatus?.timings?.operatingHours[0]?.day === EVERYDAY) {
    return storeStatus.timings?.operatingHours[0]?.availableHours?.from;
  } else {
    const operatingHrs = storeStatus?.timings?.operatingHours;
    const currentDay = getFormattedTimeWithTimeZone(storeStatus?.timeZone, format).toLowerCase();
    let dayIndex = 0,
      storeFound = [],
      currentDayStorehrs = [];
    operatingHrs?.forEach((ele, ind) => {
      const days = ele?.day?.toLowerCase();
      if (days === currentDay) {
        dayIndex = ind;
        currentDayStorehrs.push(ele);
      }
    });
    if (currentDayStorehrs?.length) {
      currentDayStorehrs?.forEach(ele => {
        const storeCurrentTime = currentTimeOfStore(storeStatus?.timeZone, DATE_FORMATS.HHmm);
        const storefromTime = removeColonFromTime(ele?.availableHours?.from);
        if (storefromTime > storeCurrentTime) {
          storeFound.push(ele);
        }
      });
    }
    if (storeFound?.length) {
      return storeFound[0]?.availableHours?.from;
    } else {
      const lastIndex = dayIndex < operatingHrs?.length - 1 ? dayIndex + 1 : dayIndex;
      return operatingHrs[lastIndex]?.availableHours?.from;
    }
  }
};

const getStyles = (isMapView, isMobile) => {
  if (isMapView && isMobile) {
    return {
      'max-height': '325px',
      margin: '0',
      position: 'absolute',
      bottom: '0',
    };
  }
};

const SearchStoreClosedCard = props => {
  const {
    key = '',
    storeName = '',
    storeDistance = '',
    orderTypes = [],
    addresses = {},
    storeStatus = {},
    onClickMapHandler,
    isMapView,
    isMobile,
    isFavoriteStore,
    addToFavoriteHandler,
    removeFromFavoriteHandler,
    map,
    loggedIn,
    storeInfo = {},
    centerIndex,
    storeLength,
    onStoreSelectFinish,
  } = props;

  const todayStartTime = getTodayStartTime(storeStatus, WEEKDAYNAME);
  const startTime = todayStartTime;
  const unavailibilitiesArray = storeStatus?.timings?.scheduled?.unavailibilities;
  const { mapText = '' } = getValueOrDefaultObject(map);
  const {
    MENU_URL,
    SEARCH_ORDER_DATA,
    CURRENT_STORE_INFO,
    DISPOSITION_DATA,
    USER_LOCALIZED,
    SCHEDULE_ORDER_DATA = '',
    SELECTED_TILE_DATA = '',
  } = START_ORDER_CONSTANTS;

  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispatch = useDispatch();
  const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(storeInfo?.summary?.timings);
  const { unavailibilities } = getValueOrDefaultObject(initiallyScheduled);
  const { interval: initialInterval = 0, startEndTime = {} } = getValueOrDefaultObject(
    initiallyScheduled?.periods?.length && initiallyScheduled?.periods[0],
  );
  const { from, to } = getValueOrDefaultObject(startEndTime);
  const { dispositionType = localStorage.getItem('dispositionType') } = userOrderState.dispositionStateData;

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;

  const orderitems = orderType => {
    return orderType.map((store, index) => {
      return (
        <div className='store-order-options' key={index}>
          <span>
            <ImageComponent data-testid='' srcFile={GreenTickImage} alt={'tick'} className='tick-image' />
          </span>
          <span>{getOrderItemsName(store)}</span>
        </div>
      );
    });
  };

  /**
   * Method to get full addresses of the store
   * @{addresses} - object - full addresses details
   */
  const getFullAddressDetails = () =>
    `${addresses.addressLines?.join(' ')} ${addresses.city} ${addresses.state} ${addresses.country} ${
      addresses.pinCode
    }`;

  /** redirect to menu page function */
  const gotoMenuPage = () => {
    const payload = {
      storeID: storeInfo?.id,
      disposition: storeInfo?.service,
      postCode: storeInfo?.addresses[0]?.address?.pinCode,
    };
    setLocalisationFinishAnalyticsData(payload);
    setStoreOutOfService(storeInfo, userOrderStateDispatch, dispositionNew, dispositionType);
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
    setSearchStoreByAtrribute();
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    props.history.push({
      pathname: `${MENU_URL}`,
    });
  };

  const checkAvailablity = () => {
    return getList(
      from,
      to,
      initialInterval,
      asap?.isAvailable,
      futureDates.length === 1 && tenantReducer?.country?.toUpperCase() === INDIA,
      unavailibilities,
    );
  };

  const scheduleOrderDispatches = storeInfoObj => {
    let store = storeInfoObj ? storeInfoObj : null;
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
    // update currently selected store info
    localStorage.setItem('currentStoreInfo', JSON.stringify(store));
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: store,
    });
  };

  /** Method to handle schedule order button click */
  const scheduleOrderButtonClickHandler = (e, selectedStoreInfo) => {
    e.preventDefault();
    e.stopPropagation();

    console.log('{{ }} schedule order button click', {
      event: e,
      store: selectedStoreInfo,
      module: selectedStoreInfo?.module,
    });

    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: false },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: true, selectedStoreInfo: selectedStoreInfo },
    });

    const {
      futureDates: futureDatesInfo,
      scheduled: initiallyScheduledData,
      asap: asapInfo,
    } = selectedStoreInfo?.summary?.timings;
    const { interval: initialIntervalData = 0, startEndTime: startEndTimeData = {} } =
      initiallyScheduledData?.periods?.length && initiallyScheduledData?.periods[0];

    const { from: initialDayStartTime, to: initialDayEndTime } = startEndTimeData;

    getList(
      initialDayStartTime,
      initialDayEndTime,
      initialIntervalData,
      asapInfo?.isAvailable,
      futureDatesInfo.length === 1 && tenantReducer?.country === 'INDIA',
    );
    setOrderLaterAnalyticsData();
    scheduleOrderDispatches(selectedStoreInfo);
    const payload = {
      storeID: selectedStoreInfo?.id,
      disposition: dispositionType,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    onStoreSelectFinish(payload);
  };

  const checkToday = date => {
    const dayAvailability = checkAvailablity().length;
    return dayAvailability ? 'Today' : 'Tomorrow';
  };

  const facilities = getFacilities(storeInfo);

  return (
    <div
      className={`store-card ${isMapView && !isMobile ? 'store-card-map-view' : 'store-card-mobile-view'}`}
      style={getStyles(isMapView, isMobile)}
      key={key}
      data-testid='closed-card'
      id='map-store-card'
    >
      <div className='d-flex'>
        <div className={`store-dist-container ${isMapView && 'map-view'}`}>
          <div className='store-name-container'>
            <span className='card-store-name'>{storeName}</span>
          </div>
          <span className='store-distance'>{getMiles(storeDistance, tenantReducer)}</span>
        </div>
        {isMapView && <span className='store-index'>{`${centerIndex + 1} of ${storeLength}`}</span>}
      </div>
      <div className='card-content'>
        <div className='order-items'>{orderitems(orderTypes)}</div>
        <div className={'w-100'}>
          {/* <span className='store-address'>{getFullAddressDetails(addresses)}</span>  Have Sonar Issue*/}
          <span className='store-address'>{getFullAddressDetails()}</span>
          {!isMapView && (
            <span className='map-link' data-testid='map-handler' onClick={() => onClickMapHandler()}>
              <AnchorWithLink className='card-map-link'>{mapText}</AnchorWithLink>
            </span>
          )}
        </div>
        <div className='info-timingClosed'>
          <ul>
            <li>
              {getAndCheckIfOneTrue(
                storeStatus.status?.currentStatus === STORE_STATUS_CLOSED_CAPS,
                storeStatus?.timings?.scheduled?.periods?.length === 0,
              ) ? (
                <span className='closed-text'>{STORE_STATUS_CLOSED}</span>
              ) : (
                ''
              )}
            </li>
            <li>
              {unavailibilitiesArray?.length > 0 &&
              parseInvalidDateAndFormat(unavailibilitiesArray[0]?.to, 'HH MM', 'HH:MM') <=
                parseInvalidDateAndFormat(to, 'HH MM', 'HH:MM')
                ? `Open Today ${
                    unavailibilitiesArray[0]?.to &&
                    parseInvalidDateAndFormat(unavailibilitiesArray[0]?.to, 'hh mm', 'hh:mm a')
                  }`
                : `Open ${checkToday(storeStatus.timings?.scheduled?.date)} ${
                    startTime && parseInvalidDateAndFormat(startTime, 'hh mm', 'hh:mm a')
                  }`}
            </li>
          </ul>
        </div>
        <div className='facilities'>
          {facilities &&
            facilities.map(item => {
              return (
                <ImageComponent
                  key={item.key}
                  data-testid=''
                  srcFile={item.image}
                  alt={item.label || ''}
                  className='facility-img'
                  title={item.label}
                />
              );
            })}
        </div>
        <div className='w-100 d-flex mt-2'>
          {loggedIn &&
            (isFavoriteStore ? (
              <ImageComponent
                data-testid='favorite-img'
                srcFile={FavoriteFillImage}
                alt={'favorite'}
                className='favorite-img'
                onClick={() => removeFromFavoriteHandler()}
              />
            ) : (
              <ImageComponent
                data-testid='unfavorite-img'
                srcFile={FavoriteUnfillImage}
                alt={'favorite'}
                className='favorite-img'
                onClick={() => addToFavoriteHandler()}
              />
            ))}
          {checkAvailablity().length > 0 ? (
            <ButtonComp
              className='button whiteButton blackBorder store-card-btn browse-menu-btn'
              data-testid='browser-menu-closed-store'
              onClickHandler={gotoMenuPage}
            >
              {translateWithI18Next(BROWSE_MENU)}
            </ButtonComp>
          ) : (
            <ButtonComp
              className='button whiteButton blackBorder search-store-card-btn schedule-order-btn'
              data-testid='schedule-order-closed-store'
              onClickHandler={event => scheduleOrderButtonClickHandler(event, storeInfo)}
            >
              {translateWithI18Next(TRANSLATE_MAPPING_KEY.SCHEDULE_ORDER_BTN)}
            </ButtonComp>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(SearchStoreClosedCard);
